export default __webpack_public_path__ + "static/media/profile.2f5c7aa5.jpg";